module.exports = __webpack_public_path__ + "img/logo สมบูรณ์ copy 2.8d605b6e.png";